import API from '../apiCreate'
import type {
  RequestCreateAutomation,
  RequestUpdateAutomation,
  RequestUpdateItemsSorting,
  ResponseAutomations,
  ResponseCrmAutomationCatalog,
  ResponseCrmAutomationExecutions,
  ResponseCrmAutoDistributionEditorData,
  ResponseCrmAutoDistributionSettings,
  CrmAutoDistributionSettings,
} from '../types/crm/crm.types'
import type { EmptyResponse } from '../types/base.types'
import type {
  CrmFunnelAutomationSettings,
  CrmFunnelAutomationSettingsResponse,
} from '../types/crm/crmFunnels.types'
import type { CrmApiRequestConfig } from './crmApiRequestConfig'

/** Правила CRM-автоматизации: `/v1/crm-automation/*`. */
export const crmAutomationApi = {
  getAllAutomations: () =>
    API.get<ResponseAutomations>('crm-automation/get-all-automations'),

  getAutomationCatalog: () =>
    API.get<ResponseCrmAutomationCatalog>(
      'crm-automation/get-automation-catalog',
    ),

  getAutomationExecutions: (id: number, limit = 50) =>
    API.get<ResponseCrmAutomationExecutions>(
      `crm-automation/get-automation-executions?id=${id}&limit=${limit}`,
    ),

  insertAutomation: (data: RequestCreateAutomation) =>
    API.post<EmptyResponse>('crm-automation/insert-automation', data),
  updateAutomation: (id: number, data: RequestUpdateAutomation) =>
    API.patch<EmptyResponse>(`crm-automation/update-automation?id=${id}`, data),
  deleteAutomation: (id: number) =>
    API.post<EmptyResponse>(`crm-automation/delete-automation?id=${id}`),

  updateAutomationsSorting: (data: RequestUpdateItemsSorting) =>
    API.put<EmptyResponse>('crm-automation/update-automations-sorting', data),

  getFunnelAutomationSettings: () =>
    API.get<CrmFunnelAutomationSettingsResponse>(
      'crm-automation/get-funnel-automation-settings',
    ),

  saveFunnelAutomationSettings: (data: CrmFunnelAutomationSettings) =>
    API.post<CrmFunnelAutomationSettingsResponse>(
      'crm-automation/save-funnel-automation-settings',
      data,
    ),

  getAutoDistributionSettings: () =>
    API.get<ResponseCrmAutoDistributionEditorData>(
      'crm-automation/get-auto-distribution-settings',
    ),

  saveAutoDistributionSettings: (
    data: CrmAutoDistributionSettings,
    config?: CrmApiRequestConfig,
  ) =>
    API.post<ResponseCrmAutoDistributionSettings>(
      'crm-automation/save-auto-distribution-settings',
      data,
      config,
    ),
}
